import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { MethodsService } from '../utils/methods.service';
import { JwtService } from '../jwt/jwt.service';
import { StorageService } from '../utils/storage.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	private _authService = inject(AuthenticationService);
	private _translateService = inject(TranslateService);
	private _methodsService = inject(MethodsService);
	private _jwtService = inject(JwtService);
	private _storageService = inject(StorageService);

	private readonly _router = inject(Router);

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			catchError((err) => {
				const error = err.error;
				if (!error.description) {
					let description = 'Nos encontramos en mantenimiento, por favor vuelve a intentarlo en unos minutos';
					if (this._translateService.currentLang === 'en')
						description = 'We are currently undergoing maintenance, please try again in a few minutes.';
					error.description = description;
				}

				// if (error.description === 'no found pubkey user') {
				// 	error.description = 'El usuario todavía no se registra en la App';
				// 	if (this._translateService.currentLang === 'en')
				// 		error.description = 'The user is not registered in the App yet';
				// }

				error.description = this._methodsService.translateDescriptionFromApi(error.description);
				const currentRoute = this._router.url;
				switch (err.status) {
					case 404:
						// if (error.renewPlan) this._router.navigate(['account'], { queryParams: { renew: true } });
						break;
					case 401:
						if (request.url.includes(environment.ia.apiUrl) || currentRoute.includes('/account')) {
							break;
						}
						// Si el 401 viene de Certero, intentar refrescar el token sin cerrar sesión de Zeyo
						if (request.url.includes('certero')) {
							this._authService.refreshToken();
							break;
						}
						// Un 401 con el access_token todavía vigente es un error de autorización puntual
						// del backend (permisos, recurso puntual, etc.), no una sesión inválida.
						// Cerrar sesión en ese caso deslogueaba al usuario sin motivo real, sobre todo
						// cuando el timer de expiredTokenInterval se congela en pestañas en segundo plano
						// y el token realmente sí venció: en ese caso sí intentamos refrescar antes de cerrar sesión.
						const storedSession = this._storageService.getAuthSession();
						const isTokenExpired =
							!storedSession?.access_token || this._jwtService.isExpiredToken(storedSession.access_token);
						if (isTokenExpired) {
							this._authService.refreshToken();
						}
						break;
					default:
						break;
				}
				return throwError(() => error);
			})
		);
	}
}
